import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ID } from '@datorama/akita';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { ImportFileResponse, ImportFileResponseEmployee, ImportItem, ImportOverview } from 'src/app/import/state/import.model';
import { ImportService } from 'src/app/import/state/import.service';
import { ImportEntityType } from '../import-by-entity/import-by-entity.component';

@Component({
    selector: 'app-import-overview',
    templateUrl: './import-overview.component.html',
    styleUrls: ['./import-overview.component.css']
})
export class ImportOverviewComponent implements OnInit {
    public import$: Observable<ImportOverview>;
    public entity: ImportEntityType;
    public importFileResponse: ImportFileResponse;
    public importFileResponseEmployee: ImportFileResponseEmployee;
    public confirmImportForm: FormGroup;

    public constructor(
        public translateService: TranslateService,
        private _importService: ImportService,
        private _route: ActivatedRoute,
        private _fb: FormBuilder
    ) { }

    public ngOnInit(): void {
        this.confirmImportForm = this._fb.group({}); // just because of preview init
        this.import$ = this._route.params
            .pipe(
                switchMap(params => this._importService.getImportByID(params.importID)),
                tap(importOverview => {
                    this.entity = importOverview.entity;
                    if (this.entity === 'EMPLOYEE') {
                        this.importFileResponseEmployee = importOverview.stats as ImportFileResponseEmployee;
                    } else {
                        this.importFileResponse = importOverview.stats as ImportFileResponse;
                    }
                })
            );
    }

    public trackByFn(index: number, importItem: ImportItem): ID {
        return importItem.import_item_ID;
    }
}
